import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./i18n";

import App from "./App";
import createStore from "./store/createStore";
import AppContainer from "./containers/AppContainer";
import reportWebVitals from "./reportWebVitals";
const { __DEV__ } = window;

// ========================================================
// Store Instantiation
// ========================================================
const initialState = window.___INITIAL_STATE__;

let store;
// ========================================================
// Render Setup
// ========================================================
const MOUNT_NODE = document.getElementById("root");

let render = async () => {
  store = await createStore(initialState);
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(<AppContainer store={store} />);
};

// ========================================================
// Developer Tools Setup
// ========================================================
if (__DEV__) {
  if (window.devToolsExtension) {
    window.devToolsExtension.open();
  }
}

// This code is excluded from production bundle
if (__DEV__) {
  if (module.hot) {
    // Development render functions
    const renderApp = render;
    const renderError = (error) => {
      const RedBox = require("redbox-react").default;

      ReactDOM.render(<RedBox error={error} />, MOUNT_NODE);
    };

    // Wrap render in try/catch
    render = () => {
      try {
        renderApp();
      } catch (error) {
        renderError(error);
      }
    };

    // Setup hot module replacement
    module.hot.accept("./containers/AppContainer", () =>
      setImmediate(() => {
        ReactDOM.unmountComponentAtNode(MOUNT_NODE);
        render();
      })
    );
  }
}

// ========================================================
// Go!
// ========================================================
render();

reportWebVitals();
